import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
  alpha,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  Dashboard as DashboardIcon,
  CheckCircle as CheckCircleIcon,
  Assignment as AssignmentIcon,
  Speed as SpeedIcon,
  TrendingUp as TrendingUpIcon,
  Security as SecurityIcon,
} from "@mui/icons-material";
import SupportLayout from "../Support/SupportLayout";

const ManageProperties = () => {
  const theme = useTheme();

  const features = [
    { icon: <DashboardIcon />, title: "One Dashboard", desc: "Manage all your listings from a single view" },
    { icon: <AssignmentIcon />, title: "Assign Cleaners", desc: "Quickly assign trusted cleaners to properties" },
    { icon: <CheckCircleIcon />, title: "Monitor Readiness", desc: "Track cleaning status in real-time" },
    { icon: <SpeedIcon />, title: "Simplify Operations", desc: "Reduce manual coordination and save hours" },
    { icon: <TrendingUpIcon />, title: "Scale Confidently", desc: "Add properties without adding stress" },
    { icon: <SecurityIcon />, title: "Quality Control", desc: "Photo verification ensures standards" },
  ];

  const stats = [
    { value: "Unlimited", label: "Properties" },
    { value: "Real-time", label: "Updates" },
    { value: "One-click", label: "Cleaner Assignment" },
    { value: "100%", label: "Visibility" },
  ];

  return (
    <SupportLayout
      title="Manage All Your Properties in One Dashboard"
      category="Services"
      subtitle="Track cleanings, cleaners, schedules, payments, and property readiness across one listing or an entire portfolio."
      breadcrumbs={[
        { label: "Services", link: "/services" },
        { label: "Manage Properties" },
      ]}
    >
      <Grid container spacing={4} sx={{ mb: 6 }}>
        {features.map((feature, idx) => (
          <Grid item xs={12} md={4} key={idx}>
            <Card sx={{ height: "100%", p: 3, borderRadius: 3 }}>
              <Box sx={{ color: theme.palette.primary.main, mb: 2 }}>
                {React.cloneElement(feature.icon, { sx: { fontSize: 40 } })}
              </Box>
              <Typography variant="h6" fontWeight="700" gutterBottom>
                {feature.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {feature.desc}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={3} sx={{ mb: 6 }}>
        {stats.map((stat, idx) => (
          <Grid item xs={6} md={3} key={idx}>
            <Card sx={{ textAlign: "center", p: 3 }}>
              <Typography variant="h4" fontWeight="800" color="primary.main">
                {stat.value}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {stat.label}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ textAlign: "center", py: 4 }}>
        <Button
          variant="contained"
          size="large"
          startIcon={<DashboardIcon />}
          sx={{ borderRadius: "50px", px: 5, py: 1.5 }}
        >
          Manage My Properties
        </Button>
      </Box>
    </SupportLayout>
  );
};

export default ManageProperties;